import React from 'react'
import "./About_us.css"
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Common_Title_1 from '../../common_components/common_title_1/Common_Title_1'

function About_us() {
    return (
        <>
            <section className='About_us section_margin'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="text_holder">

                                <Common_Title_1 titleText={"About us"}/>
                                {/* <h4>About us</h4> */}

                                <p className='info_text'>At MY MDS, we believe in making learning and growth simple, accessible, and effective. Our platform is designed to provide users with the right tools, guidance, & resources to achieve their goals with confidence. </p>

                                <p className='info_text'>We focus on innovation, quality, and trust, ensuring that every user gets a seamless experience whether it’s choosing the right plan, accessing resources, or unlocking new opportunities. With a vision to empower individuals and professionals, MY MDS is more than just a platform it’s your partner in success.</p>
                                <Link to={"/about-us"}>
                                    <Button className="search_btn">Know More</Button>
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="img_holder">
                                <img src="/assets/images/home/about_us/car.png" alt="car img" className='car_img' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_us